import { Grid } from "@material-ui/core";
import CommonButton from "app/common/Component/Button/CommonButton";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import ReceiptIcon from "@material-ui/icons/Receipt";
import { useFormikContext } from "formik";
import { observer } from "mobx-react";
import { memo } from "react";
import VoucherDepositDeductionPopup from "app/PatientManagement/PatientGeneral/PatientGeneralTabs/VoucherOrderDepositDeduction/VoucherDepositDeductionPopup";
import OrderDepositDeductionPopup from "app/PatientManagement/PatientGeneral/PatientGeneralTabs/VoucherOrderDepositDeduction/OrderDepositDeductionPopup";
import VoucherDepositDeductionTable from "app/PatientManagement/DeductionList/VoucherDepositDeductionTable";
import OrderDepositDeductionTable from "app/PatientManagement/DeductionList/OrderDepositDeductionTable";

/* 
*   Danh sách trừ tiền cọc và đơn hàng 
*   Bắt được phải có initData đầu vào
*/
const DeductionList = ((
    initRegisterTreatmentPlan,
    initRegisterService,
    initRegisterProduct,
    initChangeTreatmentPlan,
    initChangeCard,
    initChangeService,
    initChangeProduct,
) => {
    const { values, setFieldValue } = useFormikContext();
    return (
        <>
            <span class="symbol sv-section-title" >💰 Danh sách trừ tiền cọc và đơn hàng</span>
            <div className="new-product-section">
                <Grid container spacing={1}>
                    <Grid item xs={12} style={{ display: "flex", justifyContent: "space-between" }}>
                        <p className="table-section-title">
                            Danh sách trừ tiền cọc
                        </p>
                        <CommonButton
                            className="btn-primary"
                            startIcon={<AccountBalanceWalletIcon />}
                            onClick={() => {
                                setFieldValue("openVoucherDepositDeductionPopup", true)
                            }}
                        >
                            Chọn trừ tiền cọc
                        </CommonButton>
                    </Grid>
                    <VoucherDepositDeductionTable />
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={12} style={{ display: "flex", justifyContent: "space-between" }}>
                        <p className="table-section-title">
                            Danh sách trừ từ đơn hàng
                        </p>
                        <CommonButton
                            className="btn-primary ml-2"
                            startIcon={<ReceiptIcon />}
                            onClick={() => {
                                setFieldValue("openOrderDeductionPopup", true)
                            }}
                        >
                            Chọn trừ từ đơn hàng
                        </CommonButton>
                    </Grid>
                    <OrderDepositDeductionTable />
                </Grid>
            </div>

            {values?.openVoucherDepositDeductionPopup &&
                <VoucherDepositDeductionPopup
                    open={values?.openVoucherDepositDeductionPopup}
                    handleClose={() => {
                        setFieldValue("openVoucherDepositDeductionPopup", null)
                    }}
                    initRegisterTreatmentPlan={initRegisterTreatmentPlan}
                    initRegisterService={initRegisterService}
                    initRegisterProduct={initRegisterProduct}
                    initChangeTreatmentPlan={initChangeTreatmentPlan}
                    initChangeCard={initChangeCard}
                    initChangeService={initChangeService}
                    initChangeProduct={initChangeProduct}
                />
            }

            {values?.openOrderDeductionPopup &&
                <OrderDepositDeductionPopup
                    open={values?.openOrderDeductionPopup}
                    handleClose={() => {
                        setFieldValue("openOrderDeductionPopup", null)
                    }}
                    initRegisterTreatmentPlan={initRegisterTreatmentPlan}
                    initRegisterService={initRegisterService}
                    initRegisterProduct={initRegisterProduct}
                    initChangeTreatmentPlan={initChangeTreatmentPlan}
                    initChangeCard={initChangeCard}
                    initChangeService={initChangeService}
                    initChangeProduct={initChangeProduct}
                />
            }
        </>


    );
});
export default memo(observer(DeductionList));
